/**
 * @desc A HOF to create a method for appending URL params.
 * @param {string} url - URL endpoint
 * @returns {Function} Method for replacing URL params.
 */
var createURLWithParamsFactory = function (url) {
  /**
   * @param {Object} props - Key/Value pair of URL Key/URL Value
   * @returns {string} URL with params
   */
  return function (props = {}) {
    var result = url;
    Object.entries(props).forEach(([key, value]) => {
      result = result.replace(`:${key}`, value);
    });
    return result;
  };
};

/**
 * @desc A list of endpoints.
 */
export var Endpoints = {
  Webdav: {
    Upload: {
      createURL: createURLWithParamsFactory("/webdav/upload"),
      method: "POST",
    },
  },
  Convention: {
    GetAll: {
      createURL: createURLWithParamsFactory("/conventions"),
      method: "GET",
    },
    Get: {
      createURL: createURLWithParamsFactory("/convention/:name"),
      method: "GET",
    },
    GetProducts: {
      createURL: createURLWithParamsFactory("/convention/:name/products"),
      method: "GET",
    },
    Update: {
      createURL: createURLWithParamsFactory("/update-convention/:name"),
      method: "POST",
    },
    Delete: {
      createURL: createURLWithParamsFactory("/delete-convention/:name"),
      method: "POST",
    },
  },
  LiveConvention: {
    GetAll: {
      createURL: createURLWithParamsFactory("/live-conventions"),
      method: "GET",
    },
    Get: {
      createURL: createURLWithParamsFactory("/live-convention/:brand"),
      method: "GET",
    },
    Update: {
      createURL: createURLWithParamsFactory(
        "/update-live-convention/:brand/:cname"
      ),
      method: "POST",
    },
    Delete: {
      createURL: createURLWithParamsFactory("/delete-live-convention/:brand"),
      method: "POST",
    },
  },
  Login: {
    createURL: createURLWithParamsFactory("/login"),
    method: "POST",
  },
  Product: {
    GetAll: {
      createURL: createURLWithParamsFactory("/products"),
      method: "GET",
    },
    Get: {
      createURL: createURLWithParamsFactory("/product/:sku"),
      method: "GET",
    },
    Update: {
      createURL: createURLWithParamsFactory("/update-product/:sku"),
      method: "POST",
    },
    Delete: {
      createURL: createURLWithParamsFactory("/delete-product/:sku"),
      method: "POST",
    },
  },
  Wishlist: {
    GetAll: {
      createURL: createURLWithParamsFactory("/wishlists"),
      method: "GET",
    },
    Get: {
      createURL: createURLWithParamsFactory("/wishlist/:id"),
      method: "GET",
    },
    Create: {
      createURL: createURLWithParamsFactory("/create-wishlist/:cname"),
      method: "POST",
    },
    Add: {
      createURL: createURLWithParamsFactory("/add-wishlist/:psku/:id"),
      method: "POST",
    },
    Remove: {
      createURL: createURLWithParamsFactory("/remove-wishlist/:psku/:id"),
      method: "POST",
    },
    Delete: {
      createURL: createURLWithParamsFactory("/delete-wishlist/:id"),
      method: "POST",
    },
  },
};
